<template>
    <div class="tjpopup" v-show="dataVal.flag" @click.stop="handleRefund">
        <div class="tj" @click.stop>
            <div class="tj_head">
                <div class="tj_head_title">{{ dataVal.title }}</div>
            </div>
            <div class="tj_body">
                <div class="tj_title">{{ dataVal.dataname }}：</div>
                <div class="tj_input">
                    <el-input v-model="value" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="tj_body">
                <div class="tj_title">{{ dataVal.dataname }}(英文)：</div>
                <div class="tj_input">
                    <el-input v-model="valueEng" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="tj_foot">
                <div class="tj_foot_btn" @click="handleRefund">取消</div>
                <div class="tj_foot_btn tj_foot_btn2" @click="handleSubmit">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'editdata',
    props: ['dataVal'],
    data() {
        return {
            value: '',
            valueEng: ''
        }
    },
    methods: {
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("editdataCal", data);
        },
        handleSubmit() {
            let obj = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                value: this.value,
                valueEng: this.valueEng
            }
            this.$emit("editdataCal", obj);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    this.value = newVal.value
                    this.valueEng = newVal.valueEng
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss">
.tjpopup {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .tj {
        min-width: 540px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;

        .tj_head {
            width: 100%;
            height: 50px;
            background-color: #f6f6f6;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 20px;

            .tj_head_title {
                font-size: 16px;
                color: #333333;
                cursor: default;
            }
        }

        .tj_body {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 0 30px;
            margin-top: 30px;

            .tj_title {
                min-width: 120px;
                font-size: 14px;
                letter-spacing: 1px;
                color: #333333;
                text-align: right;
                flex-shrink: 0;
            }

            .tj_input {
                min-width: 360rpx;
                flex: 1;
                height: 32px;

                /deep/.el-input {
                    width: 100%;
                    height: 100%;

                    .el-input__inner {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

        .tj_foot {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 40px;
            margin-top: 30px;

            .tj_foot_btn {
                width: 80px;
                height: 32px;
                font-size: 14px;
                color: #606266;
                background-color: #ffffff;
                border-radius: 4px;
                border: solid 1px #dbdbdb;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }

            .tj_foot_btn2 {
                color: #ffffff;
                background-color: #e64a19;
                border: solid 1px #e64a19;
            }
        }
    }
}
</style>